import clsx from "clsx";
import { ReactElement, ReactNode } from "react";
import { OverlayTrigger, Popover } from "react-bootstrap";
import { Placement } from "react-bootstrap/esm/types";

import styles from "./tooltip.module.scss";

type Props = {
  id?: string;
  children: ReactElement;
  message: ReactNode;
  placement?: Placement;
};

const Tooltip = ({ children, id, message, placement }: Props) => (
  <OverlayTrigger
    trigger={["hover", "focus"]}
    placement={placement ?? "auto"}
    overlay={
      <Popover className={clsx(styles.report_popover, styles.popover)} id={id}>
        <Popover.Body>{message}</Popover.Body>
      </Popover>
    }
  >
    {children}
  </OverlayTrigger>
);

export default Tooltip;
